var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st100{\r\n        stroke:hsl(23, 80%, 56%);\r\n        stroke-width: 1.6;\r\n    }\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)",
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M6.75 6.75C7.54565 6.75 8.30871 6.43393 8.87132 5.87132C9.43393 5.30871 9.75 4.54565 9.75 3.75C9.75 2.95435 9.43393 2.19129 8.87132 1.62868C8.30871 1.06607 7.54565 0.75 6.75 0.75H4.5V6.75H6.75Z",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M4.5 2.25H1.5",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M4.5 5.25H1.5",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M9.75 3.75H18C19.1935 3.75 20.3381 4.22411 21.182 5.06802C22.0259 5.91193 22.5 7.05653 22.5 8.25C22.5 9.44347 22.0259 10.5881 21.182 11.432C20.3381 12.2759 19.1935 12.75 18 12.75H6.75C5.75544 12.75 4.80161 13.1451 4.09835 13.8483C3.39509 14.5516 3 15.5054 3 16.5C3 17.4946 3.39509 18.4484 4.09835 19.1517C4.80161 19.8549 5.75544 20.25 6.75 20.25H17.0238",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M14.0996 23.25C13.6632 23.2501 13.2321 23.1551 12.8362 22.9715C12.4404 22.7878 12.0894 22.5201 11.8077 22.1869C11.5259 21.8536 11.3203 21.4629 11.2051 21.0421C11.0899 20.6212 11.0679 20.1803 11.1406 19.75C11.2842 19.0332 11.6755 18.3898 12.246 17.9327C12.8165 17.4756 13.5297 17.2339 14.2606 17.25H16.7826C17.9674 17.2499 19.1258 17.6007 20.1116 18.258L22.1636 19.626C22.2663 19.6945 22.3505 19.7873 22.4088 19.8961C22.467 20.005 22.4975 20.1265 22.4975 20.25C22.4975 20.3735 22.467 20.495 22.4088 20.6039C22.3505 20.7127 22.2663 20.8055 22.1636 20.874L20.1116 22.242C19.1258 22.8993 17.9674 23.2501 16.7826 23.25H14.0996Z",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.622a1fd5e8bc3676cf5a7fb518979e8e.svg";
export { ForwardRef as ReactComponent };